import { memo } from "react";
import { variants } from "@8x8/oxygen-tag";
import { Tag } from "@/react/styled";

const TableMutations = ({ rowsToCreate, rowsToUpdate, rowsToDelete }) => {
  return (
    <>
      {rowsToCreate?.size > 0 && (
        <Tag marginRight={16} color="green">
          {rowsToCreate.size} added
        </Tag>
      )}
      {rowsToUpdate?.size > 0 && (
        <Tag marginRight={16} color="blue" variant={variants.blue}>
          {rowsToUpdate.size} updated
        </Tag>
      )}
      {rowsToDelete?.size > 0 && (
        <Tag marginRight={16} color="red" variant={variants.yellow}>
          {rowsToDelete.size} deleted
        </Tag>
      )}
    </>
  );
};

export default memo(TableMutations);
